import { CommonService } from "../../../../../services/CommonService";
import Nationality from "../../components/Nationality";
import { order } from "../SmartSearchParammeter";

export default async function MaritalStatusSearchConfig(key) {
  let nationality = await CommonService.getAllNationalities();
  return {
    description: "Nationality",
    id: "nationalityId",
    initial: [],
    type: order.second,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <Nationality searchObject={searchObject} onChange={onChange} t={t} />
      </div>
    ),
    operation: ["Exact"],
    list: nationality.map((m) => m.description.replace(/,/g, "#")),

    handler: function (searchObj, value) {
      searchObj["nationalityId"] = nationality
        .filter((m) => value[0] == m.description.replace(/#/g, ",").trim())
        .map((m) => m.id)
        .shift();
    }
  };
}
